
import { supabase } from '@/integrations/supabase/client';
import { JobSearchCriteria } from '@/types/jobSearch';

interface SearchAgentRequest {
  criteria: JobSearchCriteria;
  providerId: string;
}

export async function invokeSearchAgent({ criteria, providerId }: SearchAgentRequest) {
  console.log('[jobSearchUtils] Invoking search agent with criteria:', JSON.stringify(criteria, null, 2));
  console.log('[jobSearchUtils] Provider ID:', providerId);
  
  try {
    // Validate that user is authenticated
    const { data: { user }, error: authError } = await supabase.auth.getUser();
    if (authError || !user) {
      console.error('[jobSearchUtils] Authentication error:', authError);
      return {
        error: 'You must be logged in to search for jobs.',
        errorType: 'AUTHENTICATION_REQUIRED'
      };
    }

    console.log('[jobSearchUtils] User authenticated:', user.email);

    // Get the current session to extract the access token
    const { data: { session }, error: sessionError } = await supabase.auth.getSession();
    if (sessionError || !session) {
      console.error('[jobSearchUtils] Session error:', sessionError);
      return {
        error: 'Authentication session expired. Please log in again.',
        errorType: 'SESSION_EXPIRED'
      };
    }

    // Prepare the request payload with detailed logging
    const requestPayload = { 
      action: 'search_jobs',
      criteria, 
      providerId 
    };
    
    console.log('[jobSearchUtils] Full request payload being sent:', JSON.stringify(requestPayload, null, 2));

    // Call the Lutra search agent with proper authentication headers
    const { data, error } = await supabase.functions.invoke('lutra-search-agent', {
      body: requestPayload,
      headers: {
        'Authorization': `Bearer ${session.access_token}`,
        'Content-Type': 'application/json'
      }
    });

    if (error) {
      console.error('[jobSearchUtils] Edge function error:', JSON.stringify(error, null, 2));
      return {
        error: `Search service error: ${error.message}`,
        errorType: 'SEARCH_REQUEST_FAILED',
        fallbackSuggestion: 'Please try again in a few moments or contact support if the problem persists.'
      };
    }

    console.log('[jobSearchUtils] Edge function response:', JSON.stringify(data, null, 2));
    return data;

  } catch (e: any) {
    console.error('[jobSearchUtils] Exception in invokeSearchAgent:', e);
    return {
      error: `Unexpected error: ${e.message}`,
      errorType: 'UNEXPECTED_ERROR'
    };
  }
}
